import {faExclamationTriangle} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React from 'react';
import Style from 'styles/components/comachicart/price.module.scss';

const Price = ({visibleVoice}) => {
  return (
    <section className={Style.price}>
      <h2 className={classNames(Style.catch)}>
        <span>料金体系</span>
      </h2>
      <div className={classNames(Style.sub_catch)}>
        <span className={classNames(Style.purple, Style.fs30)}>
          先着 <span className={classNames(Style.underline, Style.fs30)}>90社様</span> 限定！特別プランでご案内中！
        </span>
      </div>
      <div className={classNames(Style.price__monitor)}>
        <p className={classNames(Style.white, Style.fs24)}>≪ 特別プラン ≫</p>
        <p className={classNames(Style.white, Style.fs32, Style.underline, Style.mt20)}>モニター限定プラン</p>
        <p className={classNames(Style.fs16)}>カートシステム利用料金の月額費用</p>
        <p className={classNames(Style.fs16)}>
          <span className={Style.underline}>通常価格 3,980円　→　0円</span>　に！
        </p>
        <div className={classNames(Style.price__monitor__condition)}>
          <div className={classNames(Style.price__monitor__condition__inner)}>
            <p className={classNames(Style.white)}>【お申込み条件】</p>
            <p className={classNames(Style.white, Style.left)}>・新規申込の法人/個人事業主の方</p>
            <p className={classNames(Style.white, Style.left)}>・モニター調査にご協力頂ける方</p>
          </div>
        </div>
      </div>
      <div className={classNames(Style.price__monitor__plan, Style.mt40, Style.mb40)}>
        <p>【モニター調査の内容】</p>
        <p>・インタビュー調査</p>
        <p>　インタビュー内容：ご利用前/ご利用後のサービスイメージや操作感、改善点など</p>
        <p>　インタビュー形式：対面 or オンライン</p>
        <p>　※　インタビューは録画させて頂き、弊社ＨＰへ掲載させて頂く場合がございます。</p>
        <p>・導入事例への掲載</p>
        <p>　掲載場所：弊社ＨＰ、サービスのご紹介資料など</p>
        <p>　※　掲載内容は、掲載前にお客様にご確認頂きます。</p>
        <p>　※　万が一、サービスのご解約となった場合は、掲載させて頂いた内容は削除させて頂きます。</p>
      </div>
      {visibleVoice ? (
        <>
          <h3 className={classNames(Style.dogear, Style.price__plan)}>
            <span>モニター限定プランの料金体系</span>
          </h3>
          <div className={classNames(Style.sub_catch)}>
            <span className={classNames(Style.voice)}>初期導入費用はかかりません</span>
          </div>
        </>
      ) : (
        <>
          <h3 className={classNames(Style.price__plan, Style.third_catch)}>
            <span>モニター限定プランの料金体系</span>
          </h3>
        </>
      )}
      <div className={Style.price__table}>
        <div className={Style.price__table__column}>
          <table>
            <thead>
              <tr>
                <th colSpan={2}>カートシステム利用料金</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>月額費用</td>
                <td>
                  <span className={classNames(Style.text_del)}>3,980円</span> →
                  <span className={Style.purple}> 0円</span>
                </td>
              </tr>
              <tr>
                <td>システム利用料</td>
                <td>20円</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className={Style.price__table__column}>
          <table>
            <thead>
              <tr>
                <th colSpan={2}>
                  <p className={classNames(Style.pt0, Style.pb0)}>クレジットカード決済利用料金</p>
                  <p className={classNames(Style.pt0, Style.pb0, Style.red, Style.fs12)}>※決済手段としてご利用の場合</p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>月額費用</td>
                <td>0円</td>
              </tr>
              <tr>
                <td>決済手数料</td>
                <td>3.5%</td>
              </tr>
              <tr>
                <td>売上処理料</td>
                <td>0円</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className={classNames(Style.price__notice)}>
        <span className={Style.price__notice__icon}>
          <FontAwesomeIcon className={Style.price__notice__icon__inner} icon={
    faExclamationTriangle} />
        </span>
        <div className={classNames(Style.price__notice__text)}>
          <div>※カートシステム利用料金の「システム利用料」は1注文ごとに発生致します。</div>
          <div>※クレジットカード決済利用料金は、「株式会社ゼウス」の決済サービスのご利用料金となります。</div>
          <div style={{
    color: 'red' }}>　当社経由のお申込みの場合、記載の料金が適用になります。</div>
          <div>
          　サービス内容の詳細は、
            <a
              className={classNames(Style.price__notice__link)}
              href="https://www.cardservice.co.jp/service/creditcard/"
            >
              ゼウス社のホームページ
            </a>
            をご参照ください。
          </div>
          <div>※その他、ご利用になられる決済手段に応じて、各決済サービスで定められた料金が発生致します。</div>
        </div>
      </div>
    </section>
  );
};
export default Price;
